// Thin Stimulus wrapper around modules/drive/stats-charts.js (admin ERB charts).

import { Controller } from '@hotwired/stimulus'
import { createStatsCharts, destroyStatsCharts } from '../modules/drive/stats-charts.js'

export default class extends Controller {
  static targets = ['traffic', 'extensions', 'sizes']
  static values = {
    trafficLabels: Array,
    trafficUploads: Array,
    trafficDownloads: Array,
    uploadsLabel: String,
    downloadsLabel: String,
    extensionLabels: Array,
    extensionCounts: Array,
    sizeLabels: Array,
    sizeCounts: Array,
    fileCountLabel: String,
  }

  connect() {
    this.charts = createStatsCharts({
      trafficCanvas: this.hasTrafficTarget ? this.trafficTarget : null,
      extensionsCanvas: this.hasExtensionsTarget ? this.extensionsTarget : null,
      sizesCanvas: this.hasSizesTarget ? this.sizesTarget : null,
      trafficLabels: this.trafficLabelsValue,
      trafficUploads: this.trafficUploadsValue,
      trafficDownloads: this.trafficDownloadsValue,
      uploadsLabel: this.uploadsLabelValue,
      downloadsLabel: this.downloadsLabelValue,
      extensionLabels: this.extensionLabelsValue,
      extensionCounts: this.extensionCountsValue,
      sizeLabels: this.sizeLabelsValue,
      sizeCounts: this.sizeCountsValue,
      fileCountLabel: this.fileCountLabelValue,
    })
  }

  disconnect() {
    destroyStatsCharts(this.charts)
    this.charts = []
  }
}
